import { useState, useCallback } from 'react';
import { Grid, Paper, Button, Tab, Tabs } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { getAllAutojobs, getAllAutojobs2 } from 'src/shared/services/autojobService';
import { AutojobDataGrid } from '../components/autojobDataGrid';
import { AutojobCompletedDataGrid } from '../components/autojobCompletedDataGrid';
import { AutojobErrorDataGrid } from '../components/autojobErrorDataGrid';
import { AutojobRunningDataGrid } from '../components/autojobRunningDataGrid';
import { CreateAutojobModal } from '../components/createAutojobModal';

export const AutojobSettingsPage = () => {
  const { t } = useTranslation(['settings', 'dashboard']);
  const [searchString] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const [createMode, setCreateMode] = useState(false);
  const [refetchKey, setRefetchKey] = useState(0);

  const handleSaved = useCallback(() => {
    setCreateMode(false);
    setRefetchKey((prev) => prev + 1);
  }, []);

  return (
    <GridWrapper>
      <Grid item xs={12} md={6}>
        <MainContentHeader title={t('settings:autojobs.pageTitle')} />
      </Grid>
      <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <Button onClick={() => setCreateMode(true)} variant='contained' color='secondary' startIcon={<Add />} disableElevation>
          {t('settings:autojobs.createModal.title')}
        </Button>
      </Grid>

      <Grid item xs={12}>
        <Paper>
          <Tabs value={tabIndex} onChange={(_e, newValue) => setTabIndex(newValue)}>
            <Tab label={t('settings:autojobs.statusTabs.ready')} />
            <Tab label={t('settings:autojobs.statusTabs.completed')} />
            <Tab label={t('settings:autojobs.statusTabs.error')} />
            <Tab label={t('settings:autojobs.statusTabs.running')} />
            <Tab label={t('settings:autojobs.statusTabs.onHold')} />
          </Tabs>

          {tabIndex === 0 && (
            <div key={refetchKey}>
              <AutojobDataGrid fetchFn={getAllAutojobs} searchString={searchString} status={1} title={t('settings:autojobs.tabV1')} />
              <AutojobDataGrid fetchFn={getAllAutojobs2} searchString={searchString} status={1} title={t('settings:autojobs.tabV2')} />
            </div>
          )}

          {tabIndex === 1 && (
            <div key={refetchKey}>
              <AutojobCompletedDataGrid fetchFn={getAllAutojobs} searchString={searchString} title={t('settings:autojobs.tabV1')} />
              <AutojobCompletedDataGrid fetchFn={getAllAutojobs2} searchString={searchString} title={t('settings:autojobs.tabV2')} />
            </div>
          )}

          {tabIndex === 2 && (
            <div key={refetchKey}>
              <AutojobErrorDataGrid fetchFn={getAllAutojobs} searchString={searchString} title={t('settings:autojobs.tabV1')} />
              <AutojobErrorDataGrid fetchFn={getAllAutojobs2} searchString={searchString} title={t('settings:autojobs.tabV2')} />
            </div>
          )}

          {tabIndex === 3 && (
            <div key={refetchKey}>
              <AutojobRunningDataGrid fetchFn={getAllAutojobs} searchString={searchString} title={t('settings:autojobs.tabV1')} />
              <AutojobRunningDataGrid fetchFn={getAllAutojobs2} searchString={searchString} title={t('settings:autojobs.tabV2')} />
            </div>
          )}

          {tabIndex === 4 && (
            <div key={refetchKey}>
              <AutojobDataGrid fetchFn={getAllAutojobs} searchString={searchString} status={3} title={t('settings:autojobs.tabV1')} />
              <AutojobDataGrid fetchFn={getAllAutojobs2} searchString={searchString} status={3} title={t('settings:autojobs.tabV2')} />
            </div>
          )}
        </Paper>
      </Grid>
      {createMode && <CreateAutojobModal open={createMode} onClose={() => setCreateMode(false)} onSaved={handleSaved} />}
    </GridWrapper>
  );
};
